import React, { useState } from 'react';
import { MenuItem, TextField, Button, Typography } from '@material-ui/core';
import { css } from '@emotion/core';

import SimpleSelect from '../../util/SimpleSelect';
import { VoucherTypeIdEnums, VoucherStatusTypeEnums } from '../../common/Enums';
import { FlexDiv, FormRow } from '../../styles/styles';

const FilterModal = ({ filters, handleClose, onChangeFilter }) => {
  const [values, setValues] = useState(filters);

  const setFieldValue = (type, value) => {
    const newValues = {
      ...values,
      [type]: value,
    };
    setValues(newValues);
  };

  const handleChange = type => e => {
    setFieldValue(type, e.target.value);
  };

  const onSearch = () => {
    onChangeFilter(values);
    handleClose();
  };

  const onReset = () => {
    setValues({});
  };

  const vtEnumsOptions = Object.keys(VoucherTypeIdEnums).map(key => ({
    val: Number(key),
    Name: VoucherTypeIdEnums[key],
  }));

  return (
    <FlexDiv>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          min-width: 400px;
          padding: 10px 5px;
          outline: 0 !important;
        `}
      >
        <Typography variant="h5" style={{ textAlign: 'center' }}>
          Transactions Filters
        </Typography>

        <FormRow>
          <TextField
            name="recordLimit"
            label="Record Limit"
            margin="normal"
            variant="outlined"
            fullWidth
            value={values?.recordLimit || 5000}
            onChange={handleChange('recordLimit')}
          />
        </FormRow>
        <FormRow>
          <TextField
            name="dateFilter1"
            label={<div>Start Date</div>}
            margin="normal"
            value={values?.dateFilter1 || ''}
            variant="outlined"
            fullWidth
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChange('dateFilter1')}
          />
          <TextField
            name="dateFilter2"
            label={<div>End Date</div>}
            margin="normal"
            value={values?.dateFilter2 || ''}
            variant="outlined"
            fullWidth
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleChange('dateFilter2')}
          />
        </FormRow>
        <FormRow>
          <SimpleSelect
            label="Voucher Type"
            name="voucherTypeCode"
            handleChange={handleChange('voucherTypeCode')}
            value={values?.voucherTypeCode || ''}
          >
            {vtEnumsOptions.map(({ val, Name }) => (
              <MenuItem key={val} value={val}>
                {Name}
              </MenuItem>
            ))}
          </SimpleSelect>
          <SimpleSelect
            label="Voucher Status"
            name="status"
            handleChange={handleChange('status')}
            value={values?.status || ''}
          >
            {VoucherStatusTypeEnums.map(({ val, Name }) => (
              <MenuItem key={val} value={Name}>
                {Name}
              </MenuItem>
            ))}
          </SimpleSelect>
        </FormRow>
        <FormRow>
          <TextField
            name="contact"
            label="Contact"
            margin="normal"
            variant="outlined"
            fullWidth
            value={values?.contact || ''}
            onChange={handleChange('contact')}
          />
        </FormRow>
        <FormRow style={{ justifyContent: 'center' }}>
          <Button
            size="large"
            color="secondary"
            variant="contained"
            style={{ margin: '5px' }}
            onClick={onReset}
          >
            Reset
          </Button>
          <Button
            color="primary"
            size="large"
            variant="contained"
            style={{ margin: '5px' }}
            onClick={onSearch}
          >
            Search
          </Button>
        </FormRow>
      </div>
    </FlexDiv>
  );
};

export default FilterModal;
